// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    OtherDateType,
    OtherDateTypeFromJSON,
    OtherDateTypeToJSON,
    ProfessionalTemplateAmbulanceInformation,
    ProfessionalTemplateAmbulanceInformationFromJSON,
    ProfessionalTemplateAmbulanceInformationToJSON,
    ProviderProfessionalClaimTemplateBody,
    ProviderProfessionalClaimTemplateBodyFromJSON,
    ProviderProfessionalClaimTemplateBodyToJSON,
    ProviderProfessionalTemplateServiceLine,
    ProviderProfessionalTemplateServiceLineFromJSON,
    ProviderProfessionalTemplateServiceLineToJSON,
    ResubmissionCode,
    ResubmissionCodeFromJSON,
    ResubmissionCodeToJSON,
    StateType,
    StateTypeFromJSON,
    StateTypeToJSON,
    TemplatePaperwork,
    TemplatePaperworkFromJSON,
    TemplatePaperworkToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderProfessionalClaimTemplateBodyWithClaimBody
 */
export interface ProviderProfessionalClaimTemplateBodyWithClaimBody extends ProviderProfessionalClaimTemplateBody {
    /**
     * Is the patient condition related to employment
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f10aPatientConditionRelatedToEmployment?: boolean;
    /**
     * Is the patient condition related to an automobile accident
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f10bPatientConditionRelatedToAutoAccident?: boolean;
    /**
     * 
     * OpenAPI data type: {StateType}
     * @type {StateType}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f10bPatientConditionRelatedToAutoAccidentState?: StateType;
    /**
     * Is the patient condition related to another accident
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f10cPatientConditionRelatedToOtherAccident?: boolean;
    /**
     * Date of conditions
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f14DateOfCondition?: string;
    /**
     * 
     * OpenAPI data type: {OtherDateType}
     * @type {OtherDateType}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f15OtherDateType?: OtherDateType;
    /**
     * Other from date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f15FromOtherDate?: string;
    /**
     * Other through date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f15ThroughOtherDate?: string;
    /**
     * Hospitalization from date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f18HospitalizationFromDate?: string;
    /**
     * Hospitalization from time
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f18HospitalizationFromTime?: string;
    /**
     * Hospitalization through date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f18HospitalizationThroughDate?: string;
    /**
     * Hospitalization through time
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f18HospitalizationThroughTime?: string;
    /**
     * Claim narrative description
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f19ClaimNarrative?: string;
    /**
     * Diagnosis code A
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f21aDiagnosisCode: string;
    /**
     * Diagnosis code B
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f21bDiagnosisCode?: string;
    /**
     * Diagnosis code C
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f21cDiagnosisCode?: string;
    /**
     * Diagnosis code D
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f21dDiagnosisCode?: string;
    /**
     * Diagnosis code E
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f21eDiagnosisCode?: string;
    /**
     * Diagnosis code F
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f21fDiagnosisCode?: string;
    /**
     * Diagnosis code G
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f21gDiagnosisCode?: string;
    /**
     * Diagnosis code H
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f21hDiagnosisCode?: string;
    /**
     * Diagnosis code I
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f21iDiagnosisCode?: string;
    /**
     * Diagnosis code J
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f21jDiagnosisCode?: string;
    /**
     * Diagnosis code K
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f21kDiagnosisCode?: string;
    /**
     * Diagnosis code L
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f21lDiagnosisCode?: string;
    /**
     * 
     * OpenAPI data type: {ResubmissionCode}
     * @type {ResubmissionCode}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f22ResubmissionCode?: ResubmissionCode;
    /**
     * Primary payer prior authorization number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f23PrimaryPayerPriorAuthorizationNumber?: string;
    /**
     * Secondary payer prior authorization number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f23SecondaryPayerPriorAuthorizationNumber?: string;
    /**
     * Tertiary payer prior authorization number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f23TertiaryPayerPriorAuthorizationNumber?: string;
    /**
     * The claim-level Clinical Laboratory Improvement Amendment number.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    cliaNumber?: string;
    /**
     * The claim-level referral number.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    referralNumber?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderProfessionalTemplateServiceLine>}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f24ServiceLine: Array<ProviderProfessionalTemplateServiceLine>;
    /**
     * The patient account number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f26PatientAccountNumber: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f28TotalCharge?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f29AmountPaid?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    f30Balance?: Amount;
    /**
     * 
     * OpenAPI data type: {ProfessionalTemplateAmbulanceInformation}
     * @type {ProfessionalTemplateAmbulanceInformation}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    x12Ambulance?: ProfessionalTemplateAmbulanceInformation;
    /**
     * Required on claims where anesthesiology services are being billed.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    x12AnesthesiaProcedureCode?: string;
    /**
     * Required when there is a paper attachment following this claim
     * OpenAPI data type: {array}
     * @type {Array<TemplatePaperwork>}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    x12Paperwork?: Array<TemplatePaperwork>;
    /**
     * The chargemaster item id that enforces the information in the service line
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderProfessionalClaimTemplateBodyWithClaimBody
     */
    chargemasterItemId?: string;
}

export function ProviderProfessionalClaimTemplateBodyWithClaimBodyFromJSON(json: any): ProviderProfessionalClaimTemplateBodyWithClaimBody {
    return {
                'f10aPatientConditionRelatedToEmployment': !exists(json, 'f10aPatientConditionRelatedToEmployment') ? undefined : json['f10aPatientConditionRelatedToEmployment'],
                'f10bPatientConditionRelatedToAutoAccident': !exists(json, 'f10bPatientConditionRelatedToAutoAccident') ? undefined : json['f10bPatientConditionRelatedToAutoAccident'],
                'f10bPatientConditionRelatedToAutoAccidentState': !exists(json, 'f10bPatientConditionRelatedToAutoAccidentState') ? undefined : StateTypeFromJSON(json['f10bPatientConditionRelatedToAutoAccidentState']),
                'f10cPatientConditionRelatedToOtherAccident': !exists(json, 'f10cPatientConditionRelatedToOtherAccident') ? undefined : json['f10cPatientConditionRelatedToOtherAccident'],
                'f14DateOfCondition': !exists(json, 'f14DateOfCondition') ? undefined : json['f14DateOfCondition'],
                'f15OtherDateType': !exists(json, 'f15OtherDateType') ? undefined : OtherDateTypeFromJSON(json['f15OtherDateType']),
                'f15FromOtherDate': !exists(json, 'f15FromOtherDate') ? undefined : json['f15FromOtherDate'],
                'f15ThroughOtherDate': !exists(json, 'f15ThroughOtherDate') ? undefined : json['f15ThroughOtherDate'],
                'f18HospitalizationFromDate': !exists(json, 'f18HospitalizationFromDate') ? undefined : json['f18HospitalizationFromDate'],
                'f18HospitalizationFromTime': !exists(json, 'f18HospitalizationFromTime') ? undefined : json['f18HospitalizationFromTime'],
                'f18HospitalizationThroughDate': !exists(json, 'f18HospitalizationThroughDate') ? undefined : json['f18HospitalizationThroughDate'],
                'f18HospitalizationThroughTime': !exists(json, 'f18HospitalizationThroughTime') ? undefined : json['f18HospitalizationThroughTime'],
                'f19ClaimNarrative': !exists(json, 'f19ClaimNarrative') ? undefined : json['f19ClaimNarrative'],
                'f21aDiagnosisCode': json['f21aDiagnosisCode'],
                'f21bDiagnosisCode': !exists(json, 'f21bDiagnosisCode') ? undefined : json['f21bDiagnosisCode'],
                'f21cDiagnosisCode': !exists(json, 'f21cDiagnosisCode') ? undefined : json['f21cDiagnosisCode'],
                'f21dDiagnosisCode': !exists(json, 'f21dDiagnosisCode') ? undefined : json['f21dDiagnosisCode'],
                'f21eDiagnosisCode': !exists(json, 'f21eDiagnosisCode') ? undefined : json['f21eDiagnosisCode'],
                'f21fDiagnosisCode': !exists(json, 'f21fDiagnosisCode') ? undefined : json['f21fDiagnosisCode'],
                'f21gDiagnosisCode': !exists(json, 'f21gDiagnosisCode') ? undefined : json['f21gDiagnosisCode'],
                'f21hDiagnosisCode': !exists(json, 'f21hDiagnosisCode') ? undefined : json['f21hDiagnosisCode'],
                'f21iDiagnosisCode': !exists(json, 'f21iDiagnosisCode') ? undefined : json['f21iDiagnosisCode'],
                'f21jDiagnosisCode': !exists(json, 'f21jDiagnosisCode') ? undefined : json['f21jDiagnosisCode'],
                'f21kDiagnosisCode': !exists(json, 'f21kDiagnosisCode') ? undefined : json['f21kDiagnosisCode'],
                'f21lDiagnosisCode': !exists(json, 'f21lDiagnosisCode') ? undefined : json['f21lDiagnosisCode'],
                'f22ResubmissionCode': !exists(json, 'f22ResubmissionCode') ? undefined : ResubmissionCodeFromJSON(json['f22ResubmissionCode']),
                'f23PrimaryPayerPriorAuthorizationNumber': !exists(json, 'f23PrimaryPayerPriorAuthorizationNumber') ? undefined : json['f23PrimaryPayerPriorAuthorizationNumber'],
                'f23SecondaryPayerPriorAuthorizationNumber': !exists(json, 'f23SecondaryPayerPriorAuthorizationNumber') ? undefined : json['f23SecondaryPayerPriorAuthorizationNumber'],
                'f23TertiaryPayerPriorAuthorizationNumber': !exists(json, 'f23TertiaryPayerPriorAuthorizationNumber') ? undefined : json['f23TertiaryPayerPriorAuthorizationNumber'],
                'cliaNumber': !exists(json, 'cliaNumber') ? undefined : json['cliaNumber'],
                'referralNumber': !exists(json, 'referralNumber') ? undefined : json['referralNumber'],
                'f24ServiceLine': (json['f24ServiceLine'] as Array<any>).map(ProviderProfessionalTemplateServiceLineFromJSON),
                'f26PatientAccountNumber': json['f26PatientAccountNumber'],
                'f28TotalCharge': !exists(json, 'f28TotalCharge') ? undefined : AmountFromJSON(json['f28TotalCharge']),
                'f29AmountPaid': !exists(json, 'f29AmountPaid') ? undefined : AmountFromJSON(json['f29AmountPaid']),
                'f30Balance': !exists(json, 'f30Balance') ? undefined : AmountFromJSON(json['f30Balance']),
                'x12Ambulance': !exists(json, 'x12Ambulance') ? undefined : ProfessionalTemplateAmbulanceInformationFromJSON(json['x12Ambulance']),
                'x12AnesthesiaProcedureCode': !exists(json, 'x12AnesthesiaProcedureCode') ? undefined : json['x12AnesthesiaProcedureCode'],
                'x12Paperwork': !exists(json, 'x12Paperwork') ? undefined : (json['x12Paperwork'] as Array<any>).map(TemplatePaperworkFromJSON),
                'chargemasterItemId': !exists(json, 'chargemasterItemId') ? undefined : json['chargemasterItemId'],
        ...ProviderProfessionalClaimTemplateBodyFromJSON(json)
    };

}

export function ProviderProfessionalClaimTemplateBodyWithClaimBodyToForm(value?: ProviderProfessionalClaimTemplateBodyWithClaimBody): any {
    let jsonVal = ProviderProfessionalClaimTemplateBodyWithClaimBodyToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProviderProfessionalClaimTemplateBodyWithClaimBodyToJSON(value?: ProviderProfessionalClaimTemplateBodyWithClaimBody): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'f10aPatientConditionRelatedToEmployment': cleanupBlankValuesForBackend(value.f10aPatientConditionRelatedToEmployment),
            'f10bPatientConditionRelatedToAutoAccident': cleanupBlankValuesForBackend(value.f10bPatientConditionRelatedToAutoAccident),
            'f10bPatientConditionRelatedToAutoAccidentState': StateTypeToJSON(value.f10bPatientConditionRelatedToAutoAccidentState),
            'f10cPatientConditionRelatedToOtherAccident': cleanupBlankValuesForBackend(value.f10cPatientConditionRelatedToOtherAccident),
            'f14DateOfCondition': cleanupBlankValuesForBackend(value.f14DateOfCondition),
            'f15OtherDateType': OtherDateTypeToJSON(value.f15OtherDateType),
            'f15FromOtherDate': cleanupBlankValuesForBackend(value.f15FromOtherDate),
            'f15ThroughOtherDate': cleanupBlankValuesForBackend(value.f15ThroughOtherDate),
            'f18HospitalizationFromDate': cleanupBlankValuesForBackend(value.f18HospitalizationFromDate),
            'f18HospitalizationFromTime': cleanupBlankValuesForBackend(value.f18HospitalizationFromTime),
            'f18HospitalizationThroughDate': cleanupBlankValuesForBackend(value.f18HospitalizationThroughDate),
            'f18HospitalizationThroughTime': cleanupBlankValuesForBackend(value.f18HospitalizationThroughTime),
            'f19ClaimNarrative': cleanupBlankValuesForBackend(value.f19ClaimNarrative),
            'f21aDiagnosisCode': cleanupBlankValuesForBackend(value.f21aDiagnosisCode),
            'f21bDiagnosisCode': cleanupBlankValuesForBackend(value.f21bDiagnosisCode),
            'f21cDiagnosisCode': cleanupBlankValuesForBackend(value.f21cDiagnosisCode),
            'f21dDiagnosisCode': cleanupBlankValuesForBackend(value.f21dDiagnosisCode),
            'f21eDiagnosisCode': cleanupBlankValuesForBackend(value.f21eDiagnosisCode),
            'f21fDiagnosisCode': cleanupBlankValuesForBackend(value.f21fDiagnosisCode),
            'f21gDiagnosisCode': cleanupBlankValuesForBackend(value.f21gDiagnosisCode),
            'f21hDiagnosisCode': cleanupBlankValuesForBackend(value.f21hDiagnosisCode),
            'f21iDiagnosisCode': cleanupBlankValuesForBackend(value.f21iDiagnosisCode),
            'f21jDiagnosisCode': cleanupBlankValuesForBackend(value.f21jDiagnosisCode),
            'f21kDiagnosisCode': cleanupBlankValuesForBackend(value.f21kDiagnosisCode),
            'f21lDiagnosisCode': cleanupBlankValuesForBackend(value.f21lDiagnosisCode),
            'f22ResubmissionCode': ResubmissionCodeToJSON(value.f22ResubmissionCode),
            'f23PrimaryPayerPriorAuthorizationNumber': cleanupBlankValuesForBackend(value.f23PrimaryPayerPriorAuthorizationNumber),
            'f23SecondaryPayerPriorAuthorizationNumber': cleanupBlankValuesForBackend(value.f23SecondaryPayerPriorAuthorizationNumber),
            'f23TertiaryPayerPriorAuthorizationNumber': cleanupBlankValuesForBackend(value.f23TertiaryPayerPriorAuthorizationNumber),
            'cliaNumber': cleanupBlankValuesForBackend(value.cliaNumber),
            'referralNumber': cleanupBlankValuesForBackend(value.referralNumber),
            'f24ServiceLine': (value.f24ServiceLine as Array<any>).map(ProviderProfessionalTemplateServiceLineToJSON),
            'f26PatientAccountNumber': cleanupBlankValuesForBackend(value.f26PatientAccountNumber),
            'f28TotalCharge': AmountToJSON(value.f28TotalCharge),
            'f29AmountPaid': AmountToJSON(value.f29AmountPaid),
            'f30Balance': AmountToJSON(value.f30Balance),
            'x12Ambulance': ProfessionalTemplateAmbulanceInformationToJSON(value.x12Ambulance),
            'x12AnesthesiaProcedureCode': cleanupBlankValuesForBackend(value.x12AnesthesiaProcedureCode),
            'x12Paperwork': (value.x12Paperwork === undefined || value.x12Paperwork === null) ? undefined  : (value.x12Paperwork as Array<any>).map(TemplatePaperworkToJSON),
            'chargemasterItemId': cleanupBlankValuesForBackend(value.chargemasterItemId),
            ...ProviderProfessionalClaimTemplateBodyToJSON(value)
    };
}


